// extracted by mini-css-extract-plugin
export default {"main-menu":"MainMenu_main-menu__0mmll","main-menu__item":"MainMenu_main-menu__item__qrUE2","main-menu__link":"MainMenu_main-menu__link__6Q1ob"};